import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { RiMailLine, RiArrowLeftLine } from 'react-icons/ri';
import '../styles/ForgotPassword.css';
import { useApiCall } from '../hooks/useApiCall';

const ForgotPassword = () => {
  const apiCall = useApiCall();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    
    // Clear error when user starts typing
    if (errors.email) {
      setErrors({});
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsLoading(true);

    apiCall('auth/forgot-password', 'POST', {
      email: email.trim()
    }, null, null).then((response) => {
      if(response.success){
        setEmailSent(true);
      } else {
        setErrors({ general: response?.response || 'An error occurred. Please try again.' });
      }
      setIsLoading(false);
    });
  };

  if (emailSent) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-content">
          <div className="forgot-password-form-wrapper">
            <div className="forgot-password-header">
              <div className="success-icon">
                <RiMailLine />
              </div>
              <h1>Check Your Email</h1>
              <p>We've sent a password reset link to <strong>{email}</strong></p>
              <p className="instruction-text">
                Click the link in the email to reset your password. 
                The link will expire in 1 hour for security purposes.
              </p>
            </div>

            <div className="email-actions">
              <Link to="/sign-in" className="back-to-signin-btn">
                <RiArrowLeftLine /> Back to Sign In
              </Link>
              
              <p className="resend-text">
                Didn't receive the email? 
                <button 
                  onClick={() => setEmailSent(false)} 
                  className="resend-link"
                >
                  Try again
                </button>
              </p>
            </div>
          </div>

          <div className="forgot-password-image">
            <div className="image-content">
              <h2>Building Depot Suriname</h2>
              <p>Lights & Living</p>
              <div className="image-placeholder">
                <img 
                  src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="Modern lighting display"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-content">
        <div className="forgot-password-form-wrapper">
          <div className="forgot-password-header">
            <h1>Forgot Password?</h1>
            <p>No worries! Enter your email address and we'll send you a link to reset your password.</p>
          </div>

          <form onSubmit={handleSubmit} className="forgot-password-form">
            {errors.general && (
              <div className="error-message general-error">
                {errors.general}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <div className="input-wrapper">
                <RiMailLine className="input-icon" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  className={errors.email ? 'error' : ''}
                />
              </div>
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <button 
              type="submit" 
              className="reset-btn"
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="forgot-password-footer">
            <Link to="/sign-in" className="back-to-signin">
              <RiArrowLeftLine /> Back to Sign In
            </Link>
          </div>
        </div>

        <div className="forgot-password-image">
          <div className="image-content">
            <h2>Building Depot Suriname</h2>
            <p>Lights & Living</p>
            <div className="image-placeholder">
              <img 
                src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Modern lighting display"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
